<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
  >
    <path d="M8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5ZM8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5ZM8 11C8.41421 11 8.75 11.3358 8.75 11.75C8.75 12.1642 8.41421 12.5 8 12.5C7.58579 12.5 7.25 12.1642 7.25 11.75C7.25 11.3358 7.58579 11 8 11ZM8 4.5C8.24546 4.5 8.44961 4.67688 8.49194 4.91012L8.5 5V9.5C8.5 9.77614 8.27614 10 8 10C7.75454 10 7.55039 9.82312 7.50806 9.58988L7.5 9.5V5C7.5 4.72386 7.72386 4.5 8 4.5Z" />
  </svg>
</template>
